import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppState } from '../app.state';
import { ProspektrApi } from '../_shared/api/prospektr.api';
import { AgentLoSignupState } from './agent-lo-signup.state';

@Injectable({
  providedIn: 'root',
})
export class AgentLoSignupService {
  private email$ = new BehaviorSubject<string>(null);
  private companyId$ = new BehaviorSubject<string>(null);
  private password$ = new BehaviorSubject<string>(null);
  private selectedCompany$ = new BehaviorSubject<any>({});

  constructor(
    private prospektrApi: ProspektrApi,
    public appState: AppState,
    private agentLoSignupState: AgentLoSignupState,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {}

  getSuggestedDomains(companyName: string): Observable<any> {
    return new Observable((observer) => {
      let result = [];
      observer.next({ isLoading: true });

      this.prospektrApi
        .getSuggestedDomains(companyName)
        .pipe(
          finalize(() => {
            observer.next({ isLoading: false });
            observer.complete();
          })
        )
        .subscribe(
          (response) => {
            if (
              response &&
              response.status === 'OK' &&
              response.statusCode === 200 &&
              response.data &&
              response.data.length > 0
            ) {
              result = response.data;
              observer.next({ response: result });
            } else {
              observer.next({ response: null });
            }
          },
          (err) => {
            console.error('Error fetching suggested domains:', err);
            return [];
          }
        );
    });
  }

  signUpForAgentLoanOfficer(params: any): Observable<any> {
    let response = null;
    return new Observable((observer) => {
      observer.next({ inProgress: true });
      this.prospektrApi
        .signUpForAgentLoanOfficer(params)
        .pipe(
          finalize(() => {
            observer.next({ inProgress: false, response });
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            response = res;
          },
          (error) => {
            this.openSnackBar(error?.error?.message, 'snackbar-error');
          }
        );
    });
  }

  private openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
}
